import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M15.65 2a.753.753 0 0 1 .76.769l.002.75c2.755.215 4.574 2.092 4.577 4.97L21 16.917c.004 3.138-1.968 5.069-5.128 5.074l-7.72.01c-3.14.004-5.137-1.973-5.141-5.12L3 8.553c-.004-2.898 1.752-4.77 4.506-5.023v-.75a.746.746 0 0 1 .758-.77.747.747 0 0 1 .762.769v.7l5.865-.009v-.7A.747.747 0 0 1 15.65 2m.402 14.192h-.01a.833.833 0 0 0-.808.851c.001.46.367.84.821.849a.844.844 0 0 0 .838-.852.844.844 0 0 0-.84-.848m-8.135 0c-.454.02-.81.402-.809.861.021.46.396.82.85.8.446-.02.8-.402.78-.862a.815.815 0 0 0-.821-.798m4.068-.004a.854.854 0 0 0-.809.86c.02.46.396.82.85.8.444-.022.8-.402.78-.863a.815.815 0 0 0-.821-.797m-4.073-3.593a.85.85 0 0 0-.808.86c.02.46.396.82.85.799.445-.02.8-.4.778-.86a.815.815 0 0 0-.82-.8m4.069-.035c-.454.02-.81.4-.809.86.02.46.396.819.85.799a.823.823 0 0 0 .78-.86.816.816 0 0 0-.821-.8m4.068.005a.83.83 0 0 0-.81.84v.01c.01.46.386.809.841.799a.823.823 0 0 0 .789-.852.83.83 0 0 0-.82-.797m-1.156-7.556-5.864.008v.81c0 .43-.324.77-.759.77a.75.75 0 0 1-.76-.769l-.002-.77c-1.925.193-2.99 1.325-2.988 3.493l.001.31 14.949-.02v-.35c-.043-2.148-1.121-3.276-3.056-3.444v.77c0 .43-.334.77-.758.77a.75.75 0 0 1-.762-.768z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarFilled);
export default ForwardRef;
